<template>
    <div class="projet-pokepuller">
        <div class="back-button" @click="$router.push('/projets')">
            <i class="fas fa-arrow-left"></i> Retour
        </div>
        <div class="projet-header">
            <div class="header-content">
                <img src="@/assets/logo_pokepuller.png" alt="Logo PokePuller" class="projet-logo">
                <div class="header-text">
                    <h1>Site Web "PokePuller"</h1>
                    <div class="projet-meta">
                        <span class="date">Juin 2025</span>
                        <span class="category personal">Projet Personnel</span>
                    </div>
                    <div class="competences-badges">
                        <span class="competence-badge">Gérer le patrimoine informatique</span>
                        <span class="competence-badge">Répondre aux incidents et aux demandes d'assistance et d'évolution</span>
                        <span class="competence-badge">Mettre à disposition des utilisateurs un service informatique</span>
                        <span class="competence-badge">Développer la présence en ligne de l'organisation</span>
                        <span class="competence-badge">Travailler en mode projet</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="projet-content">
            <section class="projet-section">
                <h2>Présentation du projet</h2>
                <p>
                    L'application PokéPuller dispose d'un site web permettant de mettre se mettre en avant tout en
                    proposant
                    aux utilisateurs de l'ajouter à leur répertoire d'application très facilement. Il sert également à
                    héberger les
                    conditions générales d'utilisation et la politique des données privées de l'application. L'onglet
                    Catalogue permet
                    de visualiser la collection de cartes disponible sur PokéPuller, l'utilisateur peut aussi se
                    connecter en toute sécurité
                    à Discord sur le site afin de voir son inventaire de carte et des informations sur son profile de
                    joueur.
                </p>
            </section>

            <section class="projet-section">
                <h2>Accès au site</h2>
                <a href="https://pokepuller.fr" target="_blank" rel="noopener" class="external-button">
                    Accéder au site <i class="fas fa-up-right-from-square" style="margin-left: 0.5rem;"></i>
                </a>
            </section>

            <section class="projet-section">
                <h2>Technologies utilisées</h2>
                <div class="skills-grid">
                    <div class="skill-item">
                        <h3>Vite</h3>
                        <p>Vite est le framework utilisé pour faire tourner le site web, il est déployé à l'aide de
                            Nginx.
                        </p>
                    </div>
                    <div class="skill-item">
                        <h3>Base de données</h3>
                        <p>PostgreSQL pour le stockage persistant, avec indexation optimisée pour les requêtes
                            fréquentes</p>
                    </div>
                    <div class="skill-item">
                        <h3>Intégration API</h3>
                        <p>API Discord pour gérer les connexions, API Express pour libre la base de donnée PokePuller,
                            API Python qui est le BackEnd de PokePuller pour gérer les cartes (images, données, ...).
                        </p>
                    </div>
                    <div class="skill-item">
                        <h3>Sécurité</h3>
                        <p>Il existe de nombreuses sécurités sur le site web, notament HTTPS, la communication par clés
                            RSA entre l'API Python et le site web, de l'obfuscation de code et des notifications de
                            sécurité en cas de tentative d'intrusion.</p>
                    </div>
                </div>
            </section>

            <section class="projet-section">
                <h2>Défis et solutions</h2>
                <p>
                    Le développement de PokePullerWeb a présenté plusieurs défis techniques intéressants.
                    Je n'ai jamais utilisé Vite avant ce projet, j'ai choisi ce langage spécifiquement pour apprendre
                    son fonctionnement.
                    C'est également une première pour moi de gérer un nom de domaine et de publier un site web
                    correctement référencé sur les navigateurs de recherche.
                    Pour l'aspect sécurité, la première chose que j'ai faite c'est d'utiliser Let's Encrypt afin d'avoir
                    le HTTPS et un bon référencement.
                    Gérant l'hébergement depuis chez moi avec une Raspberry Pi 5, j'ai multiplié les éfforts dans la
                    sécurité afin de ne pas rendre vulnérable l'intégralité des appareils de mon réseau domestique.
                </p>
                <p>
                    La responsivité n'est pas encore parfaite mais elle n'est pas inexistante, et il y a la possibilité
                    de se connecter via Discord afin de visualiser son inventaire de cartes Pokémon.
                </p>
            </section>

            <section class="projet-section">
                <h2>Conclusion</h2>
                <p>
                    Ce projet m'as permis de développer la présence en ligne de cette application par la mise en ligne
                    de ce site web.
                    Le référencement du site est au coeur de l'enjeux afin de valoriser son image et en faire la
                    publicité.
                    Le site fonctionne en harmonie avec les données de l'application Discord PokéPuller, évoluant
                    dynamiquement avec l'API de cartes ainsi que la base de donnée PokéPuller.
                </p>
                <p>
                    J'ai également répondu aux incidents et aux demandes d’assistance et d’évolution par un système de
                    ticketing de rapport de bugs et de suggestions d'améliorations.
                    Ces demandes sont ensuite généralement triées par catégories et traitées par ordre de priorité et de
                    gravité.
                </p>
                <p>
                    Ce site met à disposition à des utilisateurs un service informatique de type web de par son
                    déploiement avec nginx et son accès libre via URL en HTTPS et son référencement sur le net.
                </p>
                <p>
                    Je gère également le patrimoine informatique associé à PokéPuller de par la sauvegarde régulière des
                    bases de données qui tournent sur ma Raspberry pi5 qui gère l'intégralité de l'infrastructure.
                    Les sauvegardes sont réguières, automatiques et les fichiers sont stockés sur un disque à part.
                </p>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProjetPokePuller'
}
</script>

<style scoped>
.projet-pokepuller {
    padding: 2rem;
    min-height: 100vh;
    max-width: 1200px;
    margin: 0 auto;
    color: #e0e0e0;
}

.back-button {
    display: inline-flex;
    align-items: center;
    color: #FFD700;
    font-size: 1.1rem;
    margin-bottom: 2rem;
    cursor: pointer;
    transition: color 0.3s;
}

.back-button:hover {
    color: #FFF176;
}

.projet-header {
    margin-bottom: 3rem;
    border-bottom: 2px solid #FFD700;
    padding-bottom: 1.5rem;
}

.header-content {
    display: flex;
    align-items: center;
    gap: 2rem;
}

.projet-logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #FFD700;
}

.header-text {
    flex: 1;
}

h1 {
    color: #FFD700;
    font-size: 2.8rem;
    margin-bottom: 1rem;
}

.projet-meta {
    display: flex;
    gap: 1.5rem;
    font-size: 1.1rem;
}

.date {
    color: #FFF176;
}

.category {
    padding: 0.3rem 1rem;
    border-radius: 20px;
    font-weight: 500;
}

.category.personal {
    background-color: rgba(255, 215, 0, 0.1);
    color: #FFD700;
    border: 1px solid #FFD700;
}

.projet-section {
    margin-bottom: 3rem;
}

h2 {
    color: #FFF176;
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    border-left: 4px solid #FFD700;
    padding-left: 1rem;
}

h3 {
    color: #FFF59D;
    font-size: 1.4rem;
    margin-bottom: 1rem;
}

p {
    line-height: 1.7;
    margin-bottom: 1.5rem;
    font-size: 1.1rem;
    color: #B0BEC5;
}

.feature-showcase {
    display: flex;
    gap: 2rem;
    margin: 2rem 0;
    align-items: center;
    background: rgba(1, 1, 11, 0.95);
    border: 1px solid #FFD700;
    border-radius: 8px;
    padding: 2rem;
}

.feature-showcase.reverse {
    flex-direction: row-reverse;
}

.feature-image {
    width: 50%;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.feature-description {
    flex: 1;
}

.infrastructure-grid,
.skills-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin: 2rem 0;
}

.infra-item,
.skill-item {
    background: rgba(1, 1, 11, 0.95);
    border: 1px solid #FFD700;
    border-radius: 8px;
    padding: 1.5rem;
}

ul {
    padding-left: 1.5rem;
}

li {
    margin-bottom: 0.8rem;
    line-height: 1.5;
}

.architecture-diagram {
    background: rgba(1, 1, 11, 0.95);
    border: 1px solid #FFD700;
    border-radius: 8px;
    padding: 2rem;
    margin: 2rem 0;
    text-align: center;
}

.schema-image {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
}

.external-button {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    background-color: transparent;
    color: #FFD700;
    font-size: 1.1rem;
    border: 2px solid #FFD700;
    border-radius: 6px;
    text-decoration: none;
    transition: background-color 0.3s, color 0.3s;
    font-weight: 500;
    text-align: center;
}

.external-button:hover {
    background-color: #FFD700;
    color: #000;
}

.competences-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 1rem;
}

.competence-badge {
    font-size: 0.82rem;
    font-style: italic;
    padding: 0.2rem 0.7rem;
    border-radius: 4px;
    border-left: 2px solid rgba(255, 215, 0, 0.5);
    color: #FFE082;
    background: rgba(255, 215, 0, 0.1);
}

@media screen and (max-width: 768px) {

    .infrastructure-grid,
    .skills-grid {
        grid-template-columns: 1fr;
    }

    .header-content {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .projet-logo {
        width: 60px;
        height: 60px;
    }

    .feature-showcase,
    .feature-showcase.reverse {
        flex-direction: column;
    }

    .feature-image {
        width: 100%;
        margin-bottom: 1.5rem;
    }

    .feature-description {
        width: 100%;
    }
}
</style>
